// @flow
const $ = require('jquery');
require('fg-frontend/third/jquery.cookie');

const PLUGIN_NAME = 'webslider';
const DEFAULTS = {
	minScreenWidth:        768,
	data:                  [],
	controlArrows:         true,
	controlPoints:         false,
	slideTime:             5000,
	slideContentFormatter: (data) => {
		let result = '';
		result += '<ul>';
		result += data.reduce((acc, item) => {
			let itemCode = '<li>';

			if (item.link && item.link !== '') {
				itemCode += `<a href="${item.link}">`;
			}

			if (item.motive) {
				let tmpAlt = (item.title && item.title !== '') ? item.title : '';
				tmpAlt += (item.description && item.description !== '') ?
						`: ${item.description}` :
						'';
				itemCode += `<img src="${item.motive}" class="img-responsive" alt="${tmpAlt}">`;
			}

			if (item.title && item.title !== '') {
				itemCode += '<div class="description">';
				itemCode += `<h2 class="${item.mainTag}">`;
				itemCode += item.title;
				itemCode += '</h2>';
				itemCode += '</div>';
			}

			if (item.link && item.link !== '') {
				itemCode += '</a>';
			}

			itemCode += '</li>';
			return acc + itemCode;
		}, '');

		result += '</ul>';
		return result;
	},
};

// The actual plugin constructor
function WebSlider(element, options) {
	this.element = element;

	this.options = $.extend(true, {}, DEFAULTS, options);
	this.wWidth = window.innerWidth;

	this.defaults = DEFAULTS;
	this.name = PLUGIN_NAME;

	this.changeTimer = null;

	this.initialise();
}

/**
 * init
 */
WebSlider.prototype.initialise = function initialise() {
	if (this.wWidth >= this.options.minScreenWidth) {
		$(this.element).show();
		// this.actualSlide = 0;
		this.setDefaultSlide();

		if (this.options.data.length > 0) {
			this.renderSlides();
		}

		if (this.options.data.length > 1) {
			this.renderControls();
			this.startRotation();
		}
	} else {
		$(this.element).empty().hide();
	}
};

/**
 * start on random slide everytime
 */
WebSlider.prototype.setDefaultSlide = function setDefaultSlide() {
	const self = this;
	let defaultSlide = 0;
	const cookie = 'zusna-default-webslider-item';
	const cookieValue = $.cookie(cookie) || 0;

	if (cookieValue) {
		defaultSlide = parseInt(cookieValue);

		if ((defaultSlide + 1) > self.options.data.length) {
			defaultSlide = 0;
		}
	}

	let newSlide = defaultSlide + 1;

	if (newSlide + 1 > self.options.data.length) {
		newSlide = 0;
	}

	$.cookie(cookie, newSlide, { path: '/', expires: 28 });
	self.actualSlide = defaultSlide;
};

/**
 * read data and build slides list
 */
WebSlider.prototype.renderSlides = function renderSlides() {
	const htmlResult = this.options.slideContentFormatter(this.options.data);
	$(this.element).html(htmlResult);

	// show the first slide
	$('>ul:first>li', $(this.element)).fadeOut();
	$(`>ul:first>li:eq(${this.actualSlide})`, $(this.element)).fadeIn();
};

/**
 * render controls
 */
WebSlider.prototype.renderControls = function renderControls() {
	this.controlArrows = (this.options.controlArrows) ? this.renderControlArrows() : null;
	this.controlPoints = (this.options.controlPoints) ? this.renderControlPoints() : null;

	if (this.controlArrows) {
		$(this.element).append(this.controlArrows);
		this.bindControlArrows();
	}

	if (this.controlPoints) {
		$(this.element).append(this.controlPoints);
		this.bindControlPoints();
		this.updateControlPoints(this.actualSlide);
	}
};

/**
 * renders control arrows
 */
WebSlider.prototype.renderControlArrows = function renderControlArrows() {
	let str = '';
	str += '<span class="glyphicon glyphicon-arrow-left slider-arrow prev"></span>';
	str += '<span class="glyphicon glyphicon-arrow-right slider-arrow next"></span>';
	return str;
};

/**
 * bind action to control arrows
 */
WebSlider.prototype.bindControlArrows = function bindControlArrows() {
	const self = this;
	$('span.slider-arrow', $(self.element)).on('click', (event) => {
		const arrow = event.target;
		clearTimeout(self.changeTimer);
		if ($(arrow).hasClass('prev')) {
			self.rotate(self.actualSlide, 'prev');
		}

		if ($(arrow).hasClass('next')) {
			self.rotate(self.actualSlide, 'next');
		}
	});
};

/**
 * renders control points
 */
WebSlider.prototype.renderControlPoints = function renderControlPoints() {
	let str = '<ul class="control-points">';
// eslint-disable-next-line no-plusplus
	for (let i = 0; i < this.options.data.length; i++) {
		str += `<li>${i}</li>`;
	}
	str += '</ul>';
	return str;
};

/**
 * bind action to control points
 */
WebSlider.prototype.bindControlPoints = function bindControlPoints() {
	const self = this;
	clearTimeout(this.changeTimer);

	$('.control-points>li', $(this.element)).bind('click', (event) => {
		self.changeSlide(self.actualSlide, $(event.target).text());
	});
};

/**
 *
 */
WebSlider.prototype.rotate = function rotate(from, direction) {
	let newSlide = this.actualSlide;
	clearTimeout(this.changeTimer);
	if (direction === 'prev') {
		newSlide -= 1;
		newSlide = (newSlide < 0) ? this.options.data.length - 1 : newSlide;
	}

	if (direction === 'next') {
		newSlide += 1;
		newSlide = (newSlide >= this.options.data.length) ? 0 : newSlide;
	}

	this.changeSlide(this.actualSlide, newSlide);
};

/**
 *
 * @param from
 * @param to
 */
WebSlider.prototype.changeSlide = function changeSlide(from, to) {
	if (from !== to) {
		$('>ul:first>li', $(this.element)).fadeOut();
		$(`>ul:first>li:eq(${to})`, $(this.element)).fadeIn();
		this.actualSlide = to;
		this.updateControlPoints(this.actualSlide);
		this.startRotation();
	}
};

/**
 * start
 */
WebSlider.prototype.startRotation = function startRotation() {
	const self = this;
	clearTimeout(this.changeTimer);
	this.changeTimer = setTimeout(() => {
		self.rotate(self.actualSlide, 'next');
	}, self.options.slideTime);
};

/**
 * sets the right controlPoint active
 */
WebSlider.prototype.updateControlPoints = function updateControlPoints(index) {
	if (this.options.controlPoints) {
		$('.control-points li', $(this.element)).removeClass('active');
		$(`.control-points li:eq(${index})`, $(this.element)).addClass('active');
	}
};

/**
 * decide, which methods will be "public"
 */
const API = {};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *        if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *        if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[ PLUGIN_NAME ] = function plugin(value) {
	const args = arguments;

	return this.each((index, element) => {
		const $this = $(element);

		// get plugin instance
		let plugin = $this.data(`plugin_${PLUGIN_NAME}`);

		// if there's not, create one
		if (!plugin) {
			plugin = new WebSlider(this, value);
			$this.data(`plugin_${PLUGIN_NAME}`, plugin);
		} else if (API[ value ]) {
			// if there is and first parameter is in predefined API methods, call it with rest of params
			API[ value ].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.webslider.js